import BaseApp, {
  ErrorConfig,
  ErrorsConfig,
} from "@acin.reactjs/acin-ui/baseApp";
import AppLogo from "./assets/logos/AppLogo";
import loadingIcon from "./assets/lottie/loading.json";
import backendConfig from "./components/backend/backendConfig";
import CookiesBar from "./components/cookies/CookiesBar";
import sessionConfig from "./components/session/sessionConfig";
import {
  AppName,
  FallbackLng,
  localStorageLanguageKey,
} from "./constants/AppConstants";
import {
  AppBackendAPI,
  AppBackendProviderProps,
} from "./interfaces/BackendInterfaces";
import { AppParamsProps, Session } from "./interfaces/BaseAppInterfaces";
import Router from "./Router";
import appTheme, { resolveComponentsTheme } from "./theme/Theme";
import { defaultNS, translationResources } from "./translations/translations";

const envBaseUrl = import.meta.env.VITE_BASE_URL as string | undefined;
const baseUrl = envBaseUrl || window.location.origin;

const errorConfig = (errorPath: string): ErrorConfig => ({
  title: "",
  subtitle: "",
  description: "",
  icon: errorPath,
});

const errors: ErrorsConfig = {
  error401: errorConfig("401"),
  error403: errorConfig("403"),
  error404: errorConfig("404"),
  error500: errorConfig("500"),
  error503: errorConfig("500"),
};

const moduleResolver = (path: string) => () => import(`./pages/${path}.tsx`);

const lottieResolver = (path: string) => import(`./assets/lottie/${path}.json`);

const translations = {
  resources: translationResources,
  defaultNS,
  lng: localStorage.getItem(localStorageLanguageKey) ?? FallbackLng,
  fallbackLng: FallbackLng,
};

const parsedBaseUrl = new URL(baseUrl);

const App = () => (
  <BaseApp<AppParamsProps, Session, AppBackendAPI, AppBackendProviderProps>
    baseUrl={baseUrl}
    basename={parsedBaseUrl.pathname}
    appName={AppName}
    moduleResolver={moduleResolver}
    lottieResolver={lottieResolver}
    backendConf={backendConfig}
    sessionConf={sessionConfig}
    loadingIcon={loadingIcon}
    errors={errors}
    lightTheme={appTheme}
    componentsTheme={resolveComponentsTheme}
    appLogo={AppLogo}
    translations={translations}
    params={{
      apiBaseUrl: `${import.meta.env.BASE_URL}/api/`,
    }}
  >
    <Router />

    <CookiesBar />
  </BaseApp>
);

export default App;
